<template>
	<app-title-bar :icon="['fas', 'fa-info-circle']" title="Product Data"> </app-title-bar>

	<document-approval-ribbon v-if="canReview" />

	<div v-if="!loading" class="grid xl:grid-cols-3 xl:grid-rows-1 grid-cols-1 grid-rows-5 gap-4">
		<div
			v-for="category in productCategories"
			:key="category.id"
			class="w-full flex flex-col xl:flex-col items-center shadow-md font-medium text-white text-2xl rounded-lg"
			:style="{ 'background-color': category.color }">
			<div class="flex xl:flex-col items-center xl:m-10">
				<div class="w-32 xl:ml-0 xl:h-32">
					<product-category-icon
						:category="category?.id"
						:show-circle="false"
						size="xl"></product-category-icon>
				</div>
				<div class="flex flex-1 items-center text-left xl:text-center h-12">
					{{ category.name.toUpperCase() }}
				</div>
			</div>
			<div
				class="w-full flex flex-col xl:flex-row xl:max-w-6xl mt-4"
				:style="{ 'border-color': category.color }">
				<router-link
					:to="`/product-data/product-categories/${category.id}`"
					class="flex-1 text-center p-2 bg-white m-2 rounded-md"
					:style="{ color: category.color }"
					>Product Range</router-link
				>

				<router-link
					:to="`/product-data/master-groups/${category.master_group}`"
					class="flex-1 text-center p-2 bg-white m-2 rounded-md"
					:style="{ color: category.color }"
					>Stock ID</router-link
				>
			</div>
		</div>
	</div>

	<div v-else class="grid xl:grid-cols-3 xl:grid-rows-1 grid-cols-1 grid-rows-5 gap-4">
		<div
			v-for="n in 6"
			:key="n"
			class="w-full flex flex-col xl:flex-col items-center shadow-md font-medium text-white text-2xl rounded-lg bg-gray-300 animate-pulse">
			<div class="flex xl:flex-col items-center xl:m-10 w-full">
				<div class="w-28 h-28 bg-gray-200 rounded-full m-4"></div>
				<div class="h-6 w-52 bg-gray-200 rounded mb-2"></div>
			</div>
			<div class="w-full flex flex-col xl:flex-row xl:max-w-6xl mt-4">
				<div class="flex-1 text-center px-2 py-5 bg-gray-200 m-2 rounded-md h-10"></div>
				<div class="flex-1 text-center px-2 py-5 bg-gray-200 m-2 rounded-md h-10"></div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { computed, onMounted, ref } from 'vue'

	import ProductCategoryIcon from '@/components/partials/icons/ProductCategoryIcon.vue'
	import ProductCategoryService from '@/services/product-category'
	import type { ProductCategory } from '@/data/schema/product-category'
	import useAuthStore from '@/stores/auth'
	import DocumentApprovalRibbon from '@/components/partials/documents/DocumentApprovalRibbon.vue'

	const productCategories = ref<ProductCategory[]>([])

	const loading = ref(false)
	const authStore = useAuthStore()
	const canReview = computed(() => authStore.isAbleTo(['review_documents']))

	const load = async () => {
		loading.value = true
		try {
			const api = new ProductCategoryService()
			const response = await api.getAll()
			productCategories.value = response.data
			loading.value = false
		} catch {
			console.error('Error fetching product categories')
			loading.value = false
		}
	}

	onMounted(() => {
		load()
	})
</script>
